import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap';
import logoWhite from '../../assets/img/logo-white.png';
import docsWhite from '../../assets/img/docs-white.png';
import guideWhite from '../../assets/img/guide-white.png';
import paymentSystem from '../../assets/img/payment-systems.png';
import { SmoothScrollLink } from '../../utils/navUtils';
import './footer.scss';

function Footer() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;

    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    return (
        <footer className="footer-wrapper">
            <Container>
                <div className="footer-main">
                    <Row>
                        <Col lg={3} md={3} xs={12}>
                            <div className="footer-social">
                                <Nav>
                                    <SmoothScrollLink to={localizedPath('/')}>
                                        <Navbar.Brand>
                                            <img src={logoWhite} alt="logo" width="100%" />
                                        </Navbar.Brand>
                                    </SmoothScrollLink>
                                </Nav>
                                <p className="social-text">{t('footer.social-text')}</p>
                                <p className="contact-info">
                                    <span>
                                        <i>Made in Paris.</i> <br /> © 2025 Obambu SARL
                                    </span>
                                </p>
                            </div>
                        </Col>
                        <Col lg={3} md={3} xs={12}>
                            <div className="footer-services">
                                <h2 className="footer-title">{t('footer.services-title')}</h2>
                                <Nav>
                                    <SmoothScrollLink to={localizedPath('/hosting/web#page-top')}>
                                        <Nav.Link>{t('footer.web-hosting')}</Nav.Link>
                                    </SmoothScrollLink>
                                    <SmoothScrollLink to={localizedPath('/domain-name#page-top')}>
                                        <Nav.Link>{t('footer.domain-name')}</Nav.Link>
                                    </SmoothScrollLink>
                                    <SmoothScrollLink
                                        to={localizedPath('/hosting/reseller#page-top')}
                                    >
                                        <Nav.Link>{t('footer.reseller-hosting')}</Nav.Link>
                                    </SmoothScrollLink>
                                    <SmoothScrollLink
                                        to={localizedPath('/professional-business-email#page-top')}
                                    >
                                        <Nav.Link>{t('footer.business-email')}</Nav.Link>
                                    </SmoothScrollLink>
                                    <SmoothScrollLink to={localizedPath('/vps-server#page-top')}>
                                        <Nav.Link>{t('footer.vps-server')}</Nav.Link>
                                    </SmoothScrollLink>
                                </Nav>
                            </div>
                        </Col>
                        <Col lg={3} md={3} xs={12}>
                            <div className="footer-pages">
                                <h2 className="footer-title">{t('footer.pages-title')}</h2>
                                <Nav>
                                    <SmoothScrollLink to={localizedPath('/contact#page-top')}>
                                        <Nav.Link>{t('footer.contact-us')}</Nav.Link>
                                    </SmoothScrollLink>
                                    <SmoothScrollLink
                                        to={localizedPath('/affiliate-program#page-top')}
                                    >
                                        <Nav.Link>{t('footer.affiliates')}</Nav.Link>
                                    </SmoothScrollLink>
                                    <Nav.Link
                                        href="https://obambu.com/my/clientarea.php?language=english&amp;systpl=en"
                                        rel="noopener noreferrer"
                                    >
                                        {t('footer.sign-in')}
                                    </Nav.Link>
                                    <SmoothScrollLink to={localizedPath('/terms#page-top')}>
                                        <Nav.Link>{t('footer.terms')}</Nav.Link>
                                    </SmoothScrollLink>
                                </Nav>
                            </div>
                        </Col>
                        <Col lg={3} md={3} xs={12}>
                            <div className="footer-resources">
                                <h2 className="footer-title">{t('footer.resources-title')}</h2>
                                <Nav>
                                    <SmoothScrollLink to={localizedPath('/docs#page-top')}>
                                        <Nav.Link>
                                            <img src={docsWhite} alt="docs" />
                                        </Nav.Link>
                                    </SmoothScrollLink>
                                    <SmoothScrollLink to={localizedPath('/guide#page-top')}>
                                        <Nav.Link>
                                            <img src={guideWhite} alt="guide" />
                                        </Nav.Link>
                                    </SmoothScrollLink>
                                </Nav>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="footer-payment">
                    <Row>
                        <Col md={6} sm={6} xs={12}>
                            <div className="payment-left">
                                <p className="payment-text">{t('footer.price-text')}</p>
                            </div>
                        </Col>
                        <Col md={6} sm={6} xs={12} className="footer-payment-column">
                            <div className="payment-gateway">
                                <img src={paymentSystem} alt="payment-icon" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;
